import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import Submenus, { menuData } from "../components/Submenus";
import { Footer } from "../components/Footer";
import Banner from "../assets/images/sub/sub01_visual.jpg";
import homeIcon from "../assets/images/common/home.png";
import styled from "styled-components";

// Styled components for the layout
const Wrapper = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`;

const BannerImage = styled.div`
    width: 100%;
    height: 280px;
    background-image: url(${Banner});
    background-size: cover;
    background-position: center;
    
    @media all and (max-width: 768px) {
        height: 150px;
    }
`;

const MainContent = styled.div`
    display: flex;
    flex: 1;
    max-width: 1000px;
    margin: 0 auto;
    width: 100%;
    padding: 20px;
    
    @media all and (max-width: 1340px) {
        padding: 20px 10px;
    }
    
    @media all and (max-width: 768px) {
        flex-direction: column;
    }
`;

const LeftSide = styled.div`
    flex: 0 0 220px; 
    margin-right: 40px; 
    
    @media all and (max-width: 768px) {
        flex: 0 0 auto;
        margin-right: 0;
        margin-bottom: 20px;
    }
`;

const RightSide = styled.div`
    flex: 0 0 740px; 
    
    @media all and (max-width: 768px) {
        flex: 1;
    }
`;

// Outlet을 감싸는 컨테이너 추가
const OutletContainer = styled.div`
    min-height: 400px; // 최소 높이 설정
    width: 100%;
`;

// 타이틀 섹션 스타일
const CenterTop = styled.div`
    margin-bottom: 60px;
    position: relative;
    height: 50px;
    padding-top: 30px;
    width: 100%;
`;

const SubTitle = styled.h2`
    color: #555;
    font-size: 26px;
    font-weight: bold;
    border-bottom: 1px solid #8f8f8f;
    padding-bottom: 20px;
    text-align: left;
`;

const Nav = styled.ul`
    position: absolute;
    top: 40px;
    right: 0;
    display: flex;
    align-items: center;
`;

const HomeIcon = styled.img`
    width: 16px;
    height: 16px;
    margin-right: 5px;
`;

const NavItem = styled.li`
    float: left;
    padding: 0 10px 0 5px;
    font-size: 12px;
    color: #555;
    height: 14px;
    
    span {
        padding-right: 8px;
        color: #555655;
        font-size: 8px;
    }
`;

// SubLayout component
const SubLayout = () => {
    const location = useLocation();
    
    // Extract the main section from the pathname (e.g., /introduction/greeting => introduction)
    const mainSection = location.pathname.split('/')[1];
    const subSection = location.pathname.split('/')[2];
    
    // 현재 페이지 정보 가져오기
    const getCurrentPageInfo = () => {
        const mainMenuData = menuData[mainSection];
    
        if (!mainMenuData) {
            return { mainTitle: "", subTitle: "" };
        }
        
        // 서브 메뉴 정보 (items 배열에서 find 사용)
        if (subSection && mainMenuData.items) {
            const subMenuItem = mainMenuData.items.find(item => 
                item.path === `/${mainSection}/${subSection}` || 
                item.id === subSection
            );
            
            if (subMenuItem) {
                return {
                    mainTitle: mainMenuData.title,
                    subTitle: subMenuItem.name
                };
            }
        }
        
        
        return {
            mainTitle: mainMenuData.title,
            subTitle: ""
        };
    };
    
    const { mainTitle, subTitle } = getCurrentPageInfo();
    
    return (
        <Wrapper>
            <Navbar />
            <BannerImage />

            <MainContent>
                <LeftSide>
                    <Submenus section={mainSection} />
                </LeftSide>
                <RightSide>
                    <CenterTop>
                        <SubTitle>
                            {subTitle || mainTitle}
                        </SubTitle>
                        <Nav>
                            <HomeIcon src={homeIcon} alt="홈" />
                            <NavItem>Home</NavItem>
                            {mainTitle && (
                                <NavItem>
                                    <span>&gt;</span>
                                    {mainTitle}
                                </NavItem>
                            )}
                            {subTitle && (
                                <NavItem>
                                    <span>&gt;</span>
                                    {subTitle}
                                </NavItem>
                            )}
                        </Nav>
                    </CenterTop>
                    <OutletContainer>
                        <Outlet />
                    </OutletContainer>
                </RightSide>
            </MainContent>

            <Footer />
        </Wrapper>
    );
};

export default SubLayout;